import { createI18n, type I18nOptions } from 'vue-i18n'
import { supportedLanguages } from '@/i18n/supported-languages'
import type { I18nMessages } from '@/ts/types/partner-connect.types'

const initialMessages = Object.fromEntries(
  Object.entries(supportedLanguages).map(([locale, messages]) => [locale, structuredClone(messages)])
)

export function getLocaleString(): string {
  const element = document.getElementById('hyve-leasing-calculator')
  const dataLocale = element?.getAttribute('data-locale')
  if (dataLocale && dataLocale in supportedLanguages) {
    return dataLocale
  }
  if (navigator.language in supportedLanguages) {
    return navigator.language
  }
  return 'de-DE'
}

export const i18n = createI18n({
  legacy: false,
  locale: getLocaleString(),
  fallbackLocale: 'de-DE',
  globalInjection: true,
  warnHtmlMessage: false,
  fallbackWarn: false,
  missingWarn: false,
  messages: initialMessages
} as I18nOptions)

const mergeMessages = (local: Record<string, unknown>, remote: I18nMessages): Record<string, unknown> => {
  const result = { ...local }
  for (const [key, value] of Object.entries(remote)) {
    if (Array.isArray(value)) continue
    if (value && typeof value === 'object' && local[key] && typeof local[key] === 'object' && !Array.isArray(local[key])) {
      result[key] = mergeMessages(local[key] as Record<string, unknown>, value as I18nMessages)
    } else {
      result[key] = value
    }
  }
  return result
}

export function installBootstrapMessages(bootstrap: unknown): void {
  if (!bootstrap || typeof bootstrap !== 'object' || Array.isArray(bootstrap)) return
  const local = i18n.global.getLocaleMessage('de-DE') as Record<string, unknown>
  i18n.global.setLocaleMessage('de-DE', mergeMessages(local, bootstrap as I18nMessages))
}
